import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // outlet API: targets are written by populate_invitation_controller via the invitation outlet
  static targets = ["name", "email", "mobileNumber", "farmName"]
}
